import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const WhoUsesOurSolutionCard = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail desktop',
        desktop: {
          dimensions: {
            height: 680,
            width: 550,
          },
          src: '/images/new/robot-arm-mail-desktop.png',
        },
        mobile: {
          dimensions: {
            height: 704,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '35%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-25 py-lg-25 mt-lg-0 mt-n15'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          Who uses our solution?
        </h3>
        <span className='fw-semibold lh-132 fs-fluid-18-28'>
          <div>
            We are the go-to virtual office solution for banks, accountancy
            firms, and businesses.
          </div>
          <div className='fs-16-22 mt-4'>
            We excel in the highly regulated financial sector, with a proven
            track record of 100+ partner integrations, servicing 60,000+ of
            their end-users and clients. Our solution works for small firms all
            the way to prominent banks like Tide and ANNA. Opt to plug-and-play,
            or use our modern REST API to seamlessly integrate with your
            platform.
          </div>
        </span>

        <div className='d-flex flex-column flex-md-row'>
          <a className='btn btn-primary' href={'#konnect-form'}>
            Book a Demo
          </a>
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default WhoUsesOurSolutionCard
